import React from "react";
import "./Certifications.scss";
import parseWithIcons from "../utils/parseWithIcons";
import { useIsMobile } from "../hooks/useIsMobile";
import { normalizeUrl } from "../utils/normalizeUrl";

const Certifications = ({ homepage = {} }) => {
  const isMobile = useIsMobile();
  const fourthBlock = homepage?.fourthBlock || {};
  const { image = null } = fourthBlock;

  const backgroundImageSrc = image?.localFile?.childImageSharp?.fluid?.src;

  return (
    <section
      className={`section certifications-block ${
        backgroundImageSrc ? "has-background" : ""
      }`}
      style={
        backgroundImageSrc
          ? { "--background-image": `url(${backgroundImageSrc})` }
          : {}
      }
    >
      <div className="inner">
        <div className="certifications-image">
          <img
            src={fourthBlock.image?.localFile?.childImageSharp?.fluid?.src}
            alt={fourthBlock.image?.altText}
          />
        </div>
        <div className="certifications-content">
          <div className="certifications-text">
            <div className="header">
              <div></div>
              <div
                dangerouslySetInnerHTML={{
                  __html: fourthBlock.text,
                }}
              />
            </div>
            <div className="blocks">
              <div className="block-02">
                <div className="block-02-content">
                  <div className="block-02-content-text">
                    <div>
                      {parseWithIcons(fourthBlock.block2.text, "check")}
                    </div>
                  </div>
                  {fourthBlock.block2.callToAction?.title && isMobile && (
                    <a
                      href={normalizeUrl(fourthBlock.block2.callToAction.url)}
                      className="certifications-btn"
                    >
                      {fourthBlock.block2.callToAction?.title}
                    </a>
                  )}
                </div>
              </div>
              <div className="block-01">
                <div className="block-01-content">
                  <div className="block-01-content-text">
                    <div>
                      {parseWithIcons(fourthBlock.block1.text, "check")}
                    </div>
                  </div>
                  {fourthBlock.block1.callToAction?.title && !isMobile && (
                    <a
                      href={normalizeUrl(fourthBlock.block1.callToAction.url)}
                      className="certifications-btn"
                    >
                      {fourthBlock.block1.callToAction?.title}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
